import { uniq, uniqBy } from 'lodash';

import { Option } from '~/eds/src/types/Option';
import { api } from '~/redux/api/createApi';
import { sortStrings } from '~/utils/sortStrings';

import { getLatestModelVersions } from '../utils';
import { useGetModelLibraryCategories } from './useGetModelLibraryCategories';

export const useGetCategoryOptions = ({
  skip,
}: {
  skip: boolean;
}): {
  options: Option<string>[];
} => {
  const { data: models = [], isFetching } =
    api.endpoints.getLibraryModels.useQuery({}, { skip });

  let options: Option<string>[] = useGetModelLibraryCategories();
  if (!isFetching && models.length) {
    const latestModelVersions = getLatestModelVersions(models);
    const categoryLabels: string[] = uniq(
      latestModelVersions.flatMap(
        (model) => model.tags?.map((tag) => tag.label) ?? [],
      ),
    );

    const categoryOptions = categoryLabels.map((category) => ({
      label: category,
      value: category,
    }));
    const mergedOptions = uniqBy([...options, ...categoryOptions], 'label');
    options = mergedOptions.sort((a, b) => sortStrings(a.label, b.label));
  }

  return {
    options,
  };
};
